import React, {useCallback, useState} from "react";
import {FileTextOutlined, UpOutlined, DownOutlined} from "@ant-design/icons";
import moment from "moment";
import {useStore} from "hooks/useStore";
import {useFetch} from "hooks/useFetch";
import {Shortener} from "components/_defaultComponents/Shortener/Shortener";
import {GroupBox, GroupHeader, GroupContent, InnerTable} from "./LastTriedInvoices.styles";

const MISMATCH_TEXT_LENGTH = 40;

const formatAmount = val => (val != null ? `${val} ₺` : "-");

const INVOICE_TYPE_LABELS = {
    EFATURA: "E-Fatura",
    EARSIV: "E-Arşiv"
};

const columns = [
    {
        title: "Tarih",
        dataIndex: "invoiceDate",
        key: "invoiceDate",
        width: 110,
        // Fatura tarihi gün bazlı UTC gece yarısı geliyor; yerel saate çevirmeden gösteriyoruz.
        render: invoiceDate => (invoiceDate ? moment.utc(invoiceDate).format("DD.MM.YYYY") : "-"),
        onCell: () => ({"data-label": "Tarih"})
    },
    {
        title: "Fatura Tipi",
        dataIndex: "invoiceType",
        key: "invoiceType",
        render: invoiceType => INVOICE_TYPE_LABELS[invoiceType] || invoiceType || "-",
        onCell: () => ({"data-label": "Fatura Tipi"})
    },
    {
        title: "Fatura Numarası",
        dataIndex: "invoiceNumber",
        key: "invoiceNumber",
        render: invoiceNumber => invoiceNumber || "-",
        onCell: () => ({"data-label": "Fatura Numarası"})
    },
    {
        title: "Fatura Tutarı",
        dataIndex: "invoiceAmount",
        key: "invoiceAmount",
        render: formatAmount,
        onCell: () => ({"data-label": "Fatura Tutarı"})
    },
    {
        title: "Tevkifat Tutarı",
        dataIndex: "witholding",
        key: "witholding",
        render: formatAmount,
        onCell: () => ({"data-label": "Tevkifat Tutarı"})
    },
    {
        title: "Kalem Sayısı",
        dataIndex: "lineCount",
        key: "lineCount",
        render: lineCount => lineCount ?? "-",
        onCell: () => ({"data-label": "Kalem Sayısı"})
    },
    {
        title: "Eşleşmeyen Bilgiler",
        dataIndex: "mismatchReason",
        key: "mismatchReason",
        width: 320,
        render: mismatchReason => <Shortener text={mismatchReason} length={MISMATCH_TEXT_LENGTH} />,
        onCell: () => ({"data-label": "Eşleşmeyen Bilgiler"})
    }
];

export const LastTriedInvoicesTable = ({courierWithdrawRequestId}) => {
    const stores = useStore();
    const [expanded, setExpanded] = useState(true);

    const fetchNetsisInvoices = useCallback(
        () => stores.courierWithdrawRequestStore.getNetsisInvoices({courierWithdrawRequestId}),
        [courierWithdrawRequestId, stores.courierWithdrawRequestStore]
    );

    const [loading, responseData] = useFetch({
        defaultDataValue: {data: []},
        fetchFn: fetchNetsisInvoices,
        dependencies: [courierWithdrawRequestId],
        initialCall: true
    });

    const invoices = responseData?.data ?? [];

    return (
        <GroupBox>
            <GroupHeader $expanded={expanded} onClick={() => setExpanded(prev => !prev)}>
                <FileTextOutlined className="group-icon" />
                <span className="group-title">Bekleyen Faturalar</span>
                <span className="group-count">{invoices.length} fatura</span>
                {expanded ? <UpOutlined /> : <DownOutlined />}
            </GroupHeader>
            {expanded && (
                <GroupContent>
                    <InnerTable
                        columns={columns}
                        dataSource={invoices}
                        rowKey="invoiceNumber"
                        loading={loading}
                        size="small"
                        pagination={false}
                        locale={{emptyText: "Bekleyen fatura bulunamadı."}}
                    />
                </GroupContent>
            )}
        </GroupBox>
    );
};
